import { useState, useEffect, useCallback } from "react";
import { getCreaListApi } from "../api/crea.api";

const PAGE_SIZE = 15;

export const useCreaSearch = (initialPageSize = PAGE_SIZE) => {
  const [dataForm, setDataForm] = useState({});
  const [filters, setFilters] = useState({});
  const [order, setOrder] = useState("date");
  const [orderDir, setOrderDir] = useState("desc");
  const [pageSize, setPageSize] = useState(initialPageSize);
  const [pageNum, setPageNum] = useState(1);
  const [brandAdvertiserFilters, setBrandAdvertiserFilters] = useState([]);
  const [results, setResults] = useState({ data: [], totalResults: 0, totalPages: 0 });
  const [loading, setLoading] = useState(false);

  const getParsedDataForm = useCallback(() => {
    const parsedDataForm = {};
    Object.keys(dataForm).forEach((p) => {
      let key = p;
      if (p.startsWith("company_")) {
        key = p.substring("company_".length);
      }
      const val = dataForm[p];
      if (Array.isArray(val)) {
        if (val.length > 0) {
          if (key === "companyIds") {
            parsedDataForm[key] = val.map((e) => e?.id || e);
          } else {
            parsedDataForm[key] = val;
          }
        }
      } else if (typeof val === "number") {
        parsedDataForm[key] = val;
      } else if (val && val.length > 0) {
        parsedDataForm[key] = val;
      } else if (val === true || val === false) {
        parsedDataForm[key] = val;
      }
    });

    if (brandAdvertiserFilters.length > 0) {
      parsedDataForm.brand_advertiser_filters = brandAdvertiserFilters;
    }

    return parsedDataForm;
  }, [dataForm, brandAdvertiserFilters]);

  const searchRequest = useCallback(
    async (overridePageNum) => {
      setLoading(true);
      const parsedDataForm = getParsedDataForm();
      const currentPageNum = overridePageNum !== undefined ? overridePageNum : pageNum;

      const dataParams = {
        ...parsedDataForm,
        pageNum: currentPageNum,
        limit: pageSize,
      };

      if (order) {
        dataParams.sort_key = order;
        dataParams.sort_direction = orderDir;
      }

      setFilters(dataParams);

      try {
        const response = await getCreaListApi({ data: dataParams });
        setResults(response || { data: [], totalResults: 0, totalPages: 0 });
      } catch (err) {
        console.error("Error searching creativities:", err);
      } finally {
        setLoading(false);
      }
    },
    [getParsedDataForm, order, orderDir, pageNum, pageSize]
  );

  useEffect(() => {
    searchRequest(1);
    setPageNum(1);
  }, [dataForm, order, orderDir, brandAdvertiserFilters, pageSize]);

  const handleOrder = (val) => {
    if (val === order) {
      setOrderDir(orderDir === "asc" ? "desc" : "asc");
    } else {
      setOrderDir(val === "date" ? "desc" : "asc");
    }
    setOrder(val);
  };

  const resetSearch = () => {
    setDataForm({});
    setBrandAdvertiserFilters([]);
    setPageNum(1);
  };

  return {
    dataForm,
    setDataForm,
    brandAdvertiserFilters,
    setBrandAdvertiserFilters,
    filters,
    order,
    orderDir,
    pageSize,
    setPageSize,
    pageNum,
    setPageNum,
    results,
    loading,
    searchRequest,
    handleOrder,
    handlePageChange: (page, size) => {
      setPageNum(page);
      if (size !== pageSize) setPageSize(size);
      searchRequest(page);
    },
    resetSearch,
    getParsedDataForm,
  };
};

export default useCreaSearch;
